import {Container} from '~/common/fabric/CreateDesign/components/Container/Container';
import {Stamp} from '~/common/fabric/CreateDesign/components/Stamp/Stamp';
import {StampEditor} from '~/common/fabric/CreateDesign/components/Stamp/StampEditor';

export const StampContainer = () => (
  <Container>
    <Stamp />
    <StampEditor />
  </Container>
);
